/* EverydayCo motion layer — scroll-reveal engine */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ed-in');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function tag(el, delay) {
    if (el.classList.contains('ed-reveal')) return;
    el.classList.add('ed-reveal');
    if (delay) el.style.setProperty('--ed-delay', delay + 'ms');
    observer.observe(el);
  }

  function init(root) {
    root = root || document;

    // Reveal each homepage/collection section as it scrolls into view
    root.querySelectorAll('#MainContent .shopify-section').forEach(function (section) {
      // Skip sections that wrap the whole viewport height (heroes handle themselves)
      tag(section, 0);
    });

    // Stagger product cards inside grids
    root.querySelectorAll('.product-grid, [class*="product-list"]').forEach(function (grid) {
      var cards = grid.querySelectorAll('.product-card');
      cards.forEach(function (card, i) {
        tag(card, Math.min(i, 8) * 70);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-run when the theme editor or section rendering swaps content in
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
